import { Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { PlanningTable } from './components/PlanningTable';
import styles from './Planning.module.scss';
import { useGetProject } from '@/api/REST/projects';
import { useGetProjectById } from '@/api/typesense/projects/useGetProjectById';

export const Planning = () => {
  const { t } = useTranslation('projectManagement');
  const { projectId } = useParams();
  const parsedProjectId = parseInt(projectId ?? '', 10);
  const { data, isLoading } = useGetProject(
    Number.isFinite(parsedProjectId) ? parsedProjectId : null,
  );
  const { data: project, isLoading: isProjectLoading } =
    useGetProjectById(projectId);

  return (
    <Paper elevation={0} className={styles.Wrapper}>
      <Stack gap={2} padding={2} className={styles.Inner}>
        <Typography component="h2" variant="h4">
          {t('projectPlan.PageTitle')}
        </Typography>
        {Number.isFinite(parsedProjectId) && (
          <PlanningTable
            projectId={parsedProjectId}
            tasks={data?.tasks ?? []}
            currency={project?.CurrencyCode}
            isLoading={isLoading || isProjectLoading}
          />
        )}
      </Stack>
    </Paper>
  );
};
